import {
    cancelOrder,
    clinicSqbOrderPay,
    clinicSqbQueryResult,
    confirmMedicalOrderCashPayment,
    confirmMedicalOrderSelfScanPayment,
    getDicts,
    getMedicalOrderDetail
} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";
import {getSignDoctorName, updateMedicineUsageSign} from "@/assets/utils/medicineUsage";
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";
import PrescriptionGroupNotice from "@/components/PrescriptionGroupNotice.vue";

/**
 * pending 自动轮询窗口（秒）。取 150s 的两条约束：
 * ① 不得大于后端扫码支付锁的 TTL（ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）——
 *    窗口先到点而锁还在，会出现「页面已转待人工核查、收银员想重扫却被锁挡住」的自相矛盾状态；
 * ② 必须盖住后端补查阶梯 —— pending 落地时距发起已约 60s（SCAN_REQUEST_BUDGET_MS），
 *    两跳补查（间隔 +30s / +60s）落在 pending 落地后 +30s / +90s（即发起后约 +90s / +150s）；
 *    窗口从 pending 回包起算，留 60s 余量；到点后后端已有最终结论（收敛落库或自动撤单），收银员可放心关闭。
 */
const PAY_PENDING_WINDOW_SECONDS = 150;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    components: {PrescriptionGroupNotice},
    props: {
        orderId: ""
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                docPatientCaseId: null, // 关联的病历ID
                conId: null,
                serialNo: null,
                docPrice: "0.00", //诊费
                clinicalDiagnosis: null, // 诊断结果
                mainSuit: null, // 主诉
                patientMedicalHistory: null, // 既往史
                nowMedicalHistory: null, // 现病史
                patientOperationHistory: null, // 过敏史
                inspectionRecord: null, // 检查记录
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '0', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                completeTime: "",
                cancelTime: "",
                payTime: "",
                deliverWay: '1', // 配送方式
                receivePersonName: "", // 收货人姓名
                receivePhone: "", // 收货人手机
                receiveProvince: "", // 收货人所在省
                receiveCity: "", // 收货人所在市
                receiveCountry: "", // 收货人所在区
                receiveAddress: "", // 收货详细地址
            },
            doctorInfo: {
                docPrice: null,
                docPriceRate: null,
                docPriceWay: 0,
                docFreeOpen: ""
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
            payCodeList: [], // 预览的支付码
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            showOrderMedicineFuList: "",
            detailLoading: false,

            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: false, // 显示患者与费用后，仅在确定线上缴费时进入扫码等待
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            payState: "", // 支付结果三态：success / pending / failed
            payChannel: "", // 支付成功渠道：SQB / SELF_SCAN / CASH / FREE
            paymentMethod: 'SQB', // 收费方式仅在操作员确认后执行
            manualPaymentUncertain: false, // 手工登记结果不明确时禁止重复收费
            payRequestId: 0, // 支付会话epoch，复用现有requestId模式
            payDetailRequestId: 0, // 支付详情/凭证刷新版本
            payNeedsReview: false, // 外部已收款、本地待核账，绝不能重扫
            payReasonCode: "",
            payUnresolvedOrders: {}, // 关窗/换单不丢已知pending或PAID证据
            payRequesting: false, // 支付请求进行中，防止重复扫码发起第二笔扣款
            querying: false, // 「重新查询」进行中（手动与自动轮询共用，只作并发去重）
            manualQuerying: false, // 手动「重新查询」进行中：只有它会锁弹窗，自动轮询不锁
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            removeScanListener: null, // 用于存储移除扫码监听器的函数
            newRuleOpen: false, // 新规则开关（按比例换算剂量）
            decoctionNameMap: {}
        }
    },

    created() {
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });

        refreshDecoctionNameMap().then(map => {
            this.decoctionNameMap = map;
        }).finally(() => this.getMedicalOrderDetailInfo());

    },
    mounted() {
        let newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        console.log("newRuleOpen >>>>> " + newRuleOpen);
        this.newRuleOpen = newRuleOpen === 'true';
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
            this.medicalOrder.docId = this.doctorInfo.doctorId;
            if (this.doctorInfo.docPrice === null || this.doctorInfo.docPrice === undefined || this.doctorInfo.docPrice === '') {
                this.doctorInfo.docPrice = "0";
            }
            if (this.doctorInfo.docPriceRate === null || this.doctorInfo.docPriceRate === undefined || this.doctorInfo.docPriceRate === '') {
                this.doctorInfo.docPriceRate = "0";
            }
        }
        this.initScanListener();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.invalidatePaySession();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    watch: {
        'orderId': {
            flush: 'sync',
            handler() {
                this.invalidatePaySession();
                this.orderPayDialogVisible = false;
            }
        },
        orderPayDialogVisible: {
            flush: 'sync',
            handler(visible) {
                if (!visible) {
                    this.invalidatePaySession();
                }
            }
        },
    },
    computed: {
        // 三态文案：pending 绝不能被渲染成失败，否则会诱导收费员重复扫码
        payResultText() {
            if (this.payState === 'success') {
                if (this.payChannel === 'CASH') return '已现金收款';
                if (this.payChannel === 'SELF_SCAN') return '已客户自主扫码收款';
                if (this.payChannel === 'FREE') return '免费单，无需支付';
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                if (this.payNeedsReview) {
                    return '已收款，本地待核查，勿重扫';
                }
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },
        paymentMethodHint() {
            if (this.paymentMethod === 'SELF_SCAN') return '请患者使用微信扫描门诊收款码付款，核实款项已到账后点击“确定缴费”，系统将登记已支付。';
            if (this.paymentMethod === 'CASH') return '请当面点清患者支付的现金并完成找零，确认实收金额无误后点击“确定缴费”，系统将登记已支付。';
            return '点击“确定缴费”后，请患者打开微信或支付宝付款码供收钱吧盒子扫描；系统确认支付成功后更新订单。';
        },
        // 只锁「请求在途」：支付请求受 axios 70s 超时封顶、手动重查是单次查单耗时，故不可关闭时长上限≈70s。
        // pending 期间放行关闭（结果未定时关窗确实会诱导重扫，但收银员不能被关在只能干等的弹窗里）——
        // 关窗后仍有列表「查询收款结果」、服务端补查阶梯与日终对账三层兜底。
        // 用 manualQuerying 而不是 querying：后者被 10s 自动轮询共用，直接锁会让弹窗每 10 秒闪一下。
        payDialogLocked() {
            return this.payRequesting || this.manualQuerying;
        },
        canConfirmPayment() {
            return this.medicalOrder && String(this.medicalOrder.orderId) === String(this.orderId)
                && ['clinic', 'clinicRepeat'].includes(this.medicalOrder.orderSource)
                && this.medicalOrder.status === '3' && !this.detailLoading
                && !this.isPayed && !this.isWaitPayLoading && !this.manualPaymentUncertain
                && !this.payUnresolvedOrders[this.getPayOrderId()] && !this.payDialogLocked
                && ['SQB', 'CASH', 'SELF_SCAN'].includes(this.paymentMethod);
        },
        payChannelText() {
            const labels = {SQB: '线上支付（收钱吧）', CASH: '现金缴费', SELF_SCAN: '客户自主扫码', FREE: '免费单'};
            return labels[this.payChannel] || '渠道待核实';
        }
    },
    methods: {
        // 药方总重统一按处方展示克重 newGCount 累加，避免与药材明细不一致。
        getOrderWeightByNewGCount(medicineList) {
            if (!Array.isArray(medicineList)) {
                return '0.00';
            }
            const totalWeight = medicineList.reduce((total, item) => {
                const weight = parseFloat(item.newGCount);
                return total + (Number.isNaN(weight) ? 0 : weight);
            }, 0);
            return totalWeight.toFixed(2);
        },

        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading && this.paymentMethod === 'SQB') {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 复用requestId模式：epoch + 订单ID隔离旧回包、定时器和刷新凭证。
        getPayOrderId() {
            return this.orderId;
        },

        getPaySession() {
            return {requestId: this.payRequestId, orderId: this.getPayOrderId()};
        },

        isPaySessionCurrent(session) {
            return !!session && this.orderPayDialogVisible
                && session.requestId === this.payRequestId
                && session.orderId === this.getPayOrderId();
        },

        invalidatePaySession() {
            this.payRequestId++;
            this.stopPayPendingWatch();
            this.payRequesting = false;
            this.querying = false;
            this.manualQuerying = false;
        },

        resetPayScreen() {
            this.invalidatePaySession();
            this.detailLoading = true;
            this.isWaitPayLoading = false;
            this.paymentMethod = 'SQB';
            this.manualPaymentUncertain = false;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payErrorMsg = "";
            this.payState = "";
            this.payChannel = "";
            this.payNeedsReview = false;
            this.payReasonCode = "";
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            return this.getPaySession();
        },

        isPayReviewPending(payload) {
            const data = (payload && payload.data) || {};
            return !!payload && payload.code === 601 && data.payState === 'pending'
                && data.externalPayState === 'PAID' && data.localPostingState === 'needsReview'
                && data.retryAllowed === false;
        },

        restorePendingPay(session) {
            const pending = this.payUnresolvedOrders[session.orderId];
            if (!pending || !this.isPaySessionCurrent(session)) {
                return;
            }
            if (pending.reasonCode === 'MANUAL_POSTING') {
                // 手工收款结果未定时不能通过收钱吧查单推断结果；须核对真实收款记录。
                this.manualPaymentUncertain = true;
                this.payErrorMsg = '手工收款结果尚待核实，请核对收款记录及订单状态，勿重复收费。';
                this.getMedicalOrderDetailInfo(session).then(() => {
                    if (!this.isPaySessionCurrent(session) || !this.medicalOrder) return;
                    if (this.medicalOrder.payTime && this.medicalOrder.status === '1') {
                        this.manualPaymentUncertain = false;
                        delete this.payUnresolvedOrders[session.orderId];
                        this.isPayed = true;
                        this.successPayed = true;
                        this.payState = 'success';
                        this.payChannel = 'MANUAL';
                        this.payErrorMsg = '请按真实收款记录核对付款渠道，勿仅凭订单状态判断现金或扫码方式。';
                        this.$emit('order-updated');
                    }
                }).catch(() => {
                    // 回读失败继续保持锁定，避免误把未知结果当作可再次收费。
                });
                return;
            }
            this.payNeedsReview = pending.needsReview;
            this.payReasonCode = pending.reasonCode;
            this.applyPayResult({code: 601, data: {payState: 'pending'}}, true, session);
            this.requeryPayResult(false);
        },

        reviewPendingMessage() {
            return "已收款，本地待核查，请勿重复扫码，请人工核账收钱吧流水"
                + (this.payReasonCode === 'AMOUNT_MISMATCH' ? "（收款金额不符）" : "");
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            // pending和成功态只能查单，不能再次扣款。
            if (!this.orderPayDialogVisible || !this.isWaitPayLoading || this.paymentMethod !== 'SQB' || this.payRequesting
                || this.payState === 'pending' || this.payState === 'success'
                || this.payUnresolvedOrders[this.getPayOrderId()]) {
                return;
            }
            if (this.medicalOrder.orderId !== this.getPayOrderId()) {
                message("订单信息加载中，请稍后扫码", "warning");
                return;
            }
            const session = this.resetPayScreen();
            this.payRequesting = true;
            this.isWaitPayLoading = false;
            this.payLoading = true;
            // 换单/关窗可能发生在POST回包之前，先保留未知结果，重开原单只能GET。
            this.payUnresolvedOrders[session.orderId] = {needsReview: false, reasonCode: ""};
            const params = {
                orderId: session.orderId,
                price: this.medicalOrder.orderPrice,
                dynamicId: dynamicId, // 条码内容
            };
            clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                if (!this.isPaySessionCurrent(session)) {
                    return;
                }
                this.applyPayResult(response, false, session);
            }).catch(error => {
                if (!this.isPaySessionCurrent(session) || this.payState === 'success') {
                    return;
                }
                console.error('支付请求失败:', error);
                if (!error || !error.response) {
                    // 超时/断网无法证明未扣款：pending + 只读GET，绝不恢复扫码。
                    if (this.applyPayResult({code: 601, data: {payState: 'pending'}}, false, session)) {
                        this.requeryPayResult(true);
                    }
                } else {
                    // HTTP有明确响应按契约处理，不把所有500解释成pending。
                    this.applyPayResult(error.response, false, session);
                }
            }).finally(() => {
                if (this.isPaySessionCurrent(session)) {
                    this.payRequesting = false;
                }
            });
        },

        // 成功为本会话终态；已知PAID证据不能被迟到结果降级成可重扫。
        applyPayResult(response, silent, session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session)) {
                return false;
            }
            // POST是业务payload，GET是完整axios response。
            const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
            const data = (payload && payload.data) || {};
            const success = payload && payload.code === 200 && data.payState === 'success';
            if (this.payState === 'success' || (this.payNeedsReview && !success
                && !(payload && payload.code === 601 && data.payState === 'pending'))) {
                return false;
            }
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = true;
            if (success) {
                this.payState = 'success';
                this.payChannel = data.channel || '';
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payNeedsReview = false;
                this.payReasonCode = "";
                delete this.payUnresolvedOrders[session.orderId];
                this.payErrorMsg = "";
                message(this.paySuccessText(data.channel), "success");
                this.getMedicalOrderDetailInfo(session);
            } else if (payload && payload.code === 601 && data.payState === 'pending') {
                this.payState = 'pending';
                this.payChannel = "";
                this.successPayed = false;
                if (this.isPayReviewPending(payload)) {
                    this.payNeedsReview = true;
                    this.payReasonCode = data.reasonCode || "";
                }
                this.payUnresolvedOrders[session.orderId] = {
                    needsReview: this.payNeedsReview, reasonCode: this.payReasonCode
                };
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    this.startPayPendingWatch(session);
                }
                this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage()
                    : (this.payPendingExpired ? this.pendingExpiredMessage() : this.pendingMessage());
                if (!silent) {
                    message(this.payNeedsReview ? this.reviewPendingMessage() : "支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = '';
                this.successPayed = false;
                delete this.payUnresolvedOrders[session.orderId];
                this.payErrorMsg = (payload && payload.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
            return true;
        },

        paySuccessText(channel) {
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // 手动/自动查单只读；then/catch/finally共用同一会话凭证。
        requeryPayResult(silent) {
            const session = this.getPaySession();
            if (this.querying || !this.isPaySessionCurrent(session) || this.payState === 'success') {
                return;
            }
            this.querying = true;
            if (!silent) {
                this.manualQuerying = true;
            }
            clinicSqbQueryResult(session.orderId, !!silent).then(response => {
                if (!this.isPaySessionCurrent(session)) {
                    return;
                }
                this.applyPayResult(response, silent, session);
            }).catch(error => {
                if (!this.isPaySessionCurrent(session) || this.payState === 'success') {
                    return;
                }
                console.error('查询支付结果失败:', error);
                if (!silent) {
                    message("查询支付结果失败，请稍后重试", "error");
                }
            }).finally(() => {
                if (this.isPaySessionCurrent(session)) {
                    this.querying = false;
                    this.manualQuerying = false;
                }
            });
        },

        // 10s只读查单至150s；到期仍不能把未知态/已收款待核账复位成可扫码。
        startPayPendingWatch(session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session)) {
                return;
            }
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            const timer = setInterval(() => {
                if (!this.isPaySessionCurrent(session) || this.payPendingTimer !== timer) {
                    clearInterval(timer);
                    return;
                }
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired(session);
                    return;
                }
                this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage() : this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    this.requeryPayResult(true);
                }
            }, 1000);
            this.payPendingTimer = timer;
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        markPayPendingExpired(session = this.getPaySession()) {
            if (!this.isPaySessionCurrent(session) || this.payState !== 'pending') {
                return;
            }
            this.payPendingExpired = true;
            this.payErrorMsg = this.payNeedsReview ? this.reviewPendingMessage() : this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            return "支付结果超过 " + PAY_PENDING_WINDOW_SECONDS + " 秒仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },

        // 兼容历史订单中未填写的诊断字段，保留已录入内容及换行。
        diagnosisText(value) {
            return value === null || value === undefined || String(value).trim() === '' ? '暂无' : value;
        },

        // 获取订单详情信新
        getMedicalOrderDetailInfo(paySession) {
            const requestId = ++this.payDetailRequestId;
            const orderId = this.orderId;
            if (paySession) this.detailLoading = true;
            return getMedicalOrderDetail(orderId).then(response => {
                if (requestId !== this.payDetailRequestId || orderId !== this.orderId
                    || (paySession && !this.isPaySessionCurrent(paySession))) {
                    return;
                }
                console.log(response);
                if (response.data.code === 200) {
                    this.detailLoading = false;
                    this.patientInfo = response.data.data.patientInfo;
                    if (this.patientInfo.sex === "1") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                    } else if (this.patientInfo.sex === "0") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                    } else {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                    }
                    this.medicalOrder = response.data.data.medicalOrder;
                    if (this.medicalOrder.docAdvice === null) {
                        this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                    }
                    if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                        this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    }
                    this.payCodeList = [];
                    this.payCodeList.push(this.tencentCosUrl+this.medicalOrder.payQrcode);
                    if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                        this.medicalOrder.takeWay = "0";
                    }
                    if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this
                        .medicalOrder.viceNum === "") {
                        this.medicalOrder.viceNum = "1";
                    }
                    this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;
                    this.indexeat = parseInt(this.medicalOrder.takeWay === null ? '0' : this.medicalOrder.takeWay);
                    this.indexSex = parseInt(this.medicalOrder.patientSex === null ? '0' : this.medicalOrder.patientSex);

                    this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;

                    this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
                    this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
                    this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

                    this.docMedicineArray = [];
                    var orderMedicineList = this.medicalOrder.orderMedicineList;
                    console.log("orderMedicineList");
                    console.log(orderMedicineList);
                    if (orderMedicineList !== null) {
                        orderMedicineList.forEach(melist => {
                            let decoctWay = melist.decoctWay;
                            let decoctionName = getDecoctionName(decoctWay, this.decoctionNameMap);
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            if (this.medicalOrder.billingType === "0") {
                                if (melist.newGCount === null) {
                                    melist.newGCount = melist.countNum;
                                }
                                if (melist.newRatio === null) {
                                    melist.newRatio = 1;
                                }
                                if (this.newRuleOpen) {
                                    melist.countNum = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                                } else {
                                    melist.countNum = melist.newGCount;
                                }
                            } else {
                                melist.newGCount = melist.countNum;
                            }
                            if (melist.meStatus === null || melist.meStatus === "" || melist.meStatus === undefined) {
                                melist.meStatus = "0";
                            }
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.medicinePrice,
                                gCount: melist.countNum,
                                newGCount: melist.newGCount,
                                newRatio: melist.newRatio,
                                standard: melist.standard,
                                meRemark: melist.meDesc,
                                mCount: melist.totalPrice,
                                decoctionId: decoctWay,
                                decoctionName: decoctionName,
                                drugProperty: melist.drugProperty,
                                meStatus: melist.meStatus,
                                isLimitUsage: melist.isLimitUsage,
                                limitThreshold: melist.limitThreshold
                            });
                        })
                    }

                    this.chooseFuliaoList = [];
                    var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
                    console.log("orderMedicineFuList");
                    console.log(orderMedicineFuList);
                    if (orderMedicineFuList !== null) {
                        orderMedicineFuList.forEach(melist => {
                            this.chooseFuliaoList.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                meDesc: melist.meDesc,
                                price: melist.price,
                                meCount: melist.countNum,
                                countPrice: melist.totalPrice
                            });
                        })
                    }

                    if (this.docMedicineArray.length > 0) {
                        this.docMedicineArray.forEach(docMedlist => {
                            docMedlist.decoctWay = docMedlist.decoctionId;
                        });
                        this.medicalOrder.orderMedicineList = this.docMedicineArray;

                        // // ===== 临时模拟超量数据（用于核验超量签章展示效果，核验后删除本段） =====
                        // if (this.docMedicineArray[0]) {
                        //     this.docMedicineArray[0].isLimitUsage = '1';
                        //     this.docMedicineArray[0].limitThreshold = 5;
                        // }
                        // // ===== 临时模拟结束 =====

                        this.refreshUsageSigns();// 刷新超量签章信息
                    }
                    // this.reCount();
                } else {
                    this.detailLoading = true;
                    message(response.data.msg, 'error');
                }
            });

        },


        // 统一刷新药材超量签章信息（根据实际重量与限制阈值对比）
        refreshUsageSigns() {
            const doctorName = getSignDoctorName();
            this.docMedicineArray.forEach(item => updateMedicineUsageSign(item, doctorName));
        },

        // 打开处方笺
        exportOrder() {
            this.prescriptionPaperDialogDialogVisible = true;
            this.printDate = this.getDayDateNow();
        },



        // 订单收费
        openPayScreen() {
            this.orderPayDialogVisible = true;
            const session = this.resetPayScreen();
            this.getMedicalOrderDetailInfo(session).catch(() => {
                if (this.isPaySessionCurrent(session)) {
                    this.detailLoading = true;
                    message('订单详情加载失败，请关闭弹窗后重试，勿在信息未核对时收款。', 'error');
                }
            });
            this.restorePendingPay(session);
        },

        // 线上扫码由显式确认按钮开启；现金和自主扫码走服务端确认接口并回读订单状态。
        async confirmOrderPayment() {
            if (!this.orderPayDialogVisible || !this.canConfirmPayment) return;
            if (this.paymentMethod === 'SQB') {
                this.isWaitPayLoading = true;
                await this.$nextTick();
                if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }
                return;
            }
            if (!['CASH', 'SELF_SCAN'].includes(this.paymentMethod)) return;
            const session = this.getPaySession();
            const request = this.paymentMethod === 'CASH' ? confirmMedicalOrderCashPayment : confirmMedicalOrderSelfScanPayment;
            const channel = this.paymentMethod;
            this.payRequesting = true;
            this.payUnresolvedOrders[session.orderId] = {needsReview: true, reasonCode: 'MANUAL_POSTING'};
            try {
                const response = await request(session.orderId);
                if (!this.isPaySessionCurrent(session)) return;
                const result = response && response.data && response.data.code !== undefined ? response.data : response;
                if (!result || result.code !== 200) throw new Error((result && result.msg) || '确认收款失败');
                await this.getMedicalOrderDetailInfo(session);
                if (!this.isPaySessionCurrent(session)) return;
                if (!this.medicalOrder || String(this.medicalOrder.orderId) !== String(session.orderId)
                    || !this.medicalOrder.payTime || this.medicalOrder.status !== '1') {
                    throw new Error('订单入账状态尚未确认');
                }
                this.isPayed = true;
                this.successPayed = true;
                this.payState = 'success';
                this.payChannel = channel;
                delete this.payUnresolvedOrders[session.orderId];
                this.$emit('order-updated');
            } catch (error) {
                if (!this.isPaySessionCurrent(session)) return;
                this.manualPaymentUncertain = true;
                this.payErrorMsg = '收款登记或订单回读未能确认，请人工核对真实收款记录。';
                message('收款结果尚未确认，请核对真实收款记录及订单状态；请勿重复收费。', 'warning');
            } finally {
                if (this.isPaySessionCurrent(session)) this.payRequesting = false;
            }
        },

        // 仅明确失败允许刷新重扫；pending、已知PAID和成功都不允许复位。
        cancalOrRefreshPay() {
            if (this.payDialogLocked || this.payState !== 'failed'
                || this.payUnresolvedOrders[this.getPayOrderId()]) {
                return;
            }
            const session = this.resetPayScreen();
            this.getMedicalOrderDetailInfo(session);
        },

        // 打印待支付单据
        printPayInfo() {
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            this.orderPayDialogVisible = false;
            this.resetPayScreen();
        },

        // 关窗仅失效当前会话；按订单保留未决结果，重开同单必须先GET。
        cancalPay() {
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            this.orderPayDialogVisible = false;
            this.resetPayScreen();
        },

        // 取消订单
        userCancelOrder() {
            this.$confirm('确定要取消/作废当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                cancelOrder(this.orderId).then(response => {
                    if (response.data.code === 200) {
                        message("订单取消成功！", "success");
                        this.getMedicalOrderDetailInfo();
                        let navselected = this.$store.state.adminleftnavnum;
                        if (navselected === 'clinictreat') {
                            this.$emit('orderDetailStatus', false);
                        }
                    } else {
                        message("订单取消失败！", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消操作');
            })

        },



        // 修改订单
        userEditOrder() {
            this.$confirm('确定要修改当前订单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                let navselected = this.$store.state.adminleftnavnum;
                console.log(navselected);
                if (navselected !== 'clinictreat') {
                    this.$router.push({path: '/admin/clinictreat', query: { qorderId: this.orderId, qeditOrder: '0' }});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                } else {
                    window.sessionStorage.removeItem('orderId');
                    window.sessionStorage.removeItem('again');
                    window.sessionStorage.removeItem('editOrder');
                    window.sessionStorage.setItem("orderId", this.orderId);
                    window.sessionStorage.setItem("editOrder", "0");
                    this.$emit('orderDetailStatus', false);
                }
            }).catch(() => {
                console.log('用户取消操作');
            })
        },

        // 再来一单
        oneMoreOrder() {
            this.$confirm('确定依据当前订单信息再次下单吗?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem("conId");
                let navselected = this.$store.state.adminleftnavnum;
                console.log(navselected);
                if (navselected !== 'clinictreat') {
                    this.$router.push({path: '/admin/clinictreat', query: { qorderId: this.orderId, qagain: '0' }});
                    this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
                } else {
                    window.sessionStorage.removeItem('orderId');
                    window.sessionStorage.removeItem('again');
                    window.sessionStorage.removeItem('editOrder');
                    window.sessionStorage.setItem("orderId", this.orderId);
                    window.sessionStorage.setItem("again", "0");
                    this.$emit('orderDetailStatus', false);
                }
            }).catch(() => {
                console.log('用户取消操作');
            })
        },



        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
